import { Car, CarFront, ShoppingBag, TrainFront, Trees, UtensilsCrossed, ArrowUpRight } from "lucide-react";
import { DISTANCES } from "../../data/tilio";
import { Reveal, SectionHeading } from "./Shared";

const ICONS = { Car, CarFront, ShoppingBag, TrainFront, Trees, UtensilsCrossed };

const StylizedMap = () => (
    <div data-testid="map-panel" className="relative aspect-[3/4] overflow-hidden border border-stone bg-[#F4F0E5] lg:aspect-auto lg:h-full">
        <img
            src="/images/mapa-dojazd-v2.webp"
            alt="Mapa dojazdu do Tilio w Sekłaku — Warszawa 1 godzina, Łochów 15 minut, Sklep 5 minut"
            loading="lazy"
            decoding="async"
            className="h-full w-full object-contain"
        />
    </div>
);

export default function Location() {
    return (
        <section id="dojazd" data-testid="location-section" className="border-t border-stone/70 bg-white">
            <div className="mx-auto grid max-w-6xl grid-cols-1 items-stretch gap-12 px-6 py-24 lg:grid-cols-2 lg:gap-20 lg:px-10 lg:py-32">
                <div>
                    <SectionHeading
                        number="05"
                        eyebrow="Dojazd"
                        title="Gdzie jest Tilio?"
                        sub="Blisko miasta, a jednak zupełnie poza nim — nad samym Liwcem, w okolicach Łochowa."
                        center
                        testId="location-heading"
                    />
                    <Reveal delay={0.1}>
                        <ul className="mt-10 border-t border-stone">
                            {DISTANCES.map((d, i) => {
                                const Icon = ICONS[d.icon];
                                return (
                                    <li
                                        key={d.text}
                                        data-testid={`distance-item-${i}`}
                                        className="flex items-center gap-4 border-b border-stone/70 py-4"
                                    >
                                        <Icon className="h-5 w-5 shrink-0 text-pine" strokeWidth={1.25} />
                                        <span className="text-[17px] text-sage">{d.text}</span>
                                    </li>
                                );
                            })}
                        </ul>
                        <div className="mt-9 flex flex-wrap gap-3">
                            <a
                                data-testid="directions-link"
                                href="https://maps.app.goo.gl/she6CJm42mTiCmw46"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn-primary"
                            >
                                Wyznacz trasę
                                <ArrowUpRight className="h-4 w-4" strokeWidth={1.25} />
                            </a>
                        </div>
                    </Reveal>
                </div>
                <Reveal delay={0.15} className="h-full">
                    <StylizedMap />
                </Reveal>
            </div>
        </section>
    );
}
